import React from "react";
import * as R from "ramda";
import { Icon, Divider, Tooltip } from "antd";
import { Link } from "react-router-dom";
import { css } from "glamor";

import { BackButtonTopbar } from "@arachnys/styleguide/PageHeader";
import { formatWithJsonSchema } from "../../formatters";
import { getValueFromPath, getCountrySource } from "../../util";
import MergedEntityIcon from "./merged-entity-icon";
import MonitoringIcon from "./EntityMonitoring";

const styles = {
    topbarTitle: css({
        fontSize: 24,
        fontWeight: "bold",
    }),
    divider: css({
        margin: "5px 0 !important",
    }),
    mergeIcon: css({
        width: 18,
        height: 18,
        color: "#fff",
        marginLeft: 10,
    }),
    tooltipTitle: css({
        fontSize: 13,
    }),
    tooltipSubtitile: css({
        fontSize: 10,
    }),
    tooltipLink: css({
        fontSize: 10,
        "& a": {
            color: "#fff",
            textDecoration: "underline",
        },
    }),
    descriptionList: ({ gutter, col }) =>
        css({
            display: "grid",
            gridTemplateColumns: Array(col)
                .fill("auto")
                .join(" "),
            gridTemplateRows: "auto",
            gridColumnGap: gutter,
            gridRowGap: gutter,
        }),
};

const MergedTooltip = ({ mergedEntities }) => (
    <>
        <div className={styles.tooltipTitle}>Merged Entity</div>
        <div className={styles.tooltipSubtitile}>Original entities</div>
        {mergedEntities.map(entity => (
            <div key={entity.key.ulid} className={styles.tooltipLink}>
                <Link to={`/entities/${entity.key.ulid}/`}>{entity.name}</Link>
            </div>
        ))}
    </>
);

export const EntityProfile = ({
    entity,
    schema,
    refetchEntity,
    sentryPolicySchema,
    backLink,
    additionalData,
    gutter = 8,
    col = 2,
}) => {
    const entityData = formatWithJsonSchema({
        jsonSchema: schema,
        data: entity,
    });

    const descriptionData = {
        "Entity ID": entityData.key.ulid,
        Country: getValueFromPath(
            `${getCountrySource(entity)}Address.countryCode`,
            entityData,
            ".",
            "Unknown"
        ),
        "Risk Level": entityData.riskLevel,
        ...additionalData,
    };

    const DescriptionItems = R.values(
        R.mapObjIndexed(
            (value, key) => (
                <div key={key}>
                    <strong>{key}:&nbsp;</strong>
                    {value}
                </div>
            ),
            descriptionData
        )
    );

    return (
        <BackButtonTopbar link={backLink || "/entities/"}>
            <div>
                <div>
                    <span className={styles.topbarTitle}>{entity.name}</span>
                    {entity.childMergedEntities.length ? (
                        <Tooltip
                            placement="right"
                            title={
                                <MergedTooltip
                                    mergedEntities={entity.childMergedEntities}
                                />
                            }
                        >
                            <Icon
                                className={`${styles.mergeIcon}`}
                                component={MergedEntityIcon}
                            />
                        </Tooltip>
                    ) : null}
                    {refetchEntity ? (
                        <MonitoringIcon
                            refetchEntity={refetchEntity}
                            entity={entity}
                            schema={sentryPolicySchema}
                        />
                    ) : null}
                </div>
                <Divider {...styles.divider} />
                <div className={styles.descriptionList({ col, gutter })}>
                    {DescriptionItems}
                </div>
                <Divider {...styles.divider} />
            </div>
        </BackButtonTopbar>
    );
};
